import { passThroughAxios } from './passThrough.axios'

export default {
  setExternalReference(quoteId, externalReference) {
    return passThroughAxios.put(`quotes/${quoteId}/external-reference`, { externalReference })
  },
}
